const timesheetActivityServiceName = "/Activity";

export function timesheetActivityService(http) {
    return {      
        addNewActivityAsync: (data) => {

            return http.post(timesheetActivityServiceName + "/CreateCostCenterNewActivityAsync", {
                activityCode: data.activityCode,
                activityDescription: data.activityDescription,
                activityDiscipline: data.activityDiscipline,
                activityDisciplineProject: data.activityDisciplineProject,
                costCenterCode: data.costCenter,

                isActive: data.active.checked,
                isOmit: data.omit.checked,
                isConceptualDesign: data.conceptualDesign.checked,
                isBasicDesign: data.basicDesign.checked,
                isDetailDesign: data.detailDesign.checked,
                isProcurement: data.procurement.checked,
                isProjectManagement: data.projectManagement.checked,
                isFeasibilityStudy: data.fs.checked,
                isVendor: data.vdr.checked
            })
        },
        modifyExistingActivityAsync: (data) => {
            return http.post(timesheetActivityServiceName + "/ModifyExistingActivityAsync", data)
        },
        deleteCostCenterActivityAsync: async (activityCode, costCenterCode, activityDiscipline, activityDisciplineProject) => {
        const parameters = {
            activityCode,
            costCenterCode,
            activityDiscipline,
            activityDisciplineProject
        }

        return await http.post(timesheetActivityServiceName + '/DeleteCostCenterActivityAsync', parameters);
        },
        deleteCostCenterActivitiesAsync: async activities => {
            return await http.post(timesheetActivityServiceName + '/DeleteCostCenterActivitiesAsync', activities);
        },
        undeleteCostCenterActivitiesAsync: async activities => {
            return await http.post(timesheetActivityServiceName + '/UndeleteCostCenterActivitiesAsync', activities);
        },
        activateCostCenterActivitiesAsync: async activities => {
            return await http.post(timesheetActivityServiceName + '/ActivateCostCenterActivitiesAsync', activities);
        }, 
        deactivateCostCenterActivitiesAsync: async activities => {
            return await http.post(timesheetActivityServiceName + '/DeactivateCostCenterActivitiesAsync', activities);
        },                
        getUploadedActivitiesFileAsync: (activityFileInfo) => {
            return http.post(timesheetActivityServiceName + "/GetUploadedActivitiesFileAsync", activityFileInfo, { responseType: "blob" });
        },
    }
}
